import { BarChart, Codesandbox, Maximize2 } from 'react-feather';
import './exercise.css';
import { AnimatePresence, motion } from "motion/react"
import { useEffect, useState } from 'react';
import Pattern from '../pattern/pattern';
import toast from 'react-hot-toast';
import Shredieck from '../shredieck/shredieck';
function Exercise({user,data,kind,loading,app}) {
  const [isOpen, setIsOpen ] =useState(false);
  const open = ()=>{
    if(loading){
      return;
    }
    if(!user){
      toast.error('You need to sign in to access the exercises!')
      return;
    }
    setIsOpen(true);
  }
  const close = (e)=>{
    if(e.keyCode==27)
      setIsOpen(false);
  }
  useEffect(()=>{
document.addEventListener('keyup',close)
    return ()=>{
      document.removeEventListener('keyup',close);
    }
  },[])
  return (
    <div className={kind=='shredieck'?loading?'exerciseWrapper exerciseWrapperShredieck loadingEx':'exerciseWrapper exerciseWrapperShredieck':loading?'exerciseWrapper loadingEx':'exerciseWrapper'}>
    <motion.div
    transition={{type:'spring',bounce:.25,duration:.5}}
    drag={isOpen?'y':''}
  dragConstraints={{ top: 0,bottom:0 }}
dragElastic={{top:0,bottom:.4}}
onDragEnd={(e,i)=>{
  if(i.offset.y > 50){
    setIsOpen(false)
  }
}}
    style={
      isOpen?{
        position:'fixed',
        top:50,
        zIndex:10,
        left:0,
        bottom:0,
        right:0,
        background:'#fff',
        borderWidth:0,
        borderTopLeftRadius:25,
        borderTopRightRadius:25,
        borderBottomLeftRadius:0,
        padding:0,
        borderBottomRightRadius:0,
      }:{

  borderTopRightRadius: 10,
  borderBottomRightRadius: 10,
  borderTopLeftRadius: 10,
  borderBottomLeftRadius: 10
      }
    } onClick={open} layout className={isOpen?'exercise isOpen':'exercise'}>
      {isOpen?<div className='overlay' onClick={(e)=>{e.stopPropagation();setIsOpen(false)}}></div>:<></>}
      <AnimatePresence>
      {isOpen?kind=='shredieck'?<Shredieck user={user} app={app}/>:kind.kind==2?<Pattern app={app} user={user} id={data.id}/>:<Pattern app={app} user={user} scale={true} id={data.id}/>:kind=='shredieck'?
      <div><img src="/bg.png" className='img'/></div>:
      <motion.div>
      <div className='exerciseIcon flex flexCenterX flexCenterY'>
        <div>
          <div className='icon flex flexCenterX flexCenterY'>{kind.kind==1?<BarChart/>:<Codesandbox/>}</div>
          <div className='exerciseMetas flex flexCenterX flexCenterY'>
            {kind.extension?<div className='exerciseMeta noPadding flex flexCenterX flexCenterY'>
              <Maximize2/>
            </div>:<></>}
            <div className='exerciseMeta flex flexCenterX flexCenterY'>
              {data.description}
            </div>
            
          </div>
        </div>
      </div>
      <h3>{data.title}</h3>
      <small>{data.description} strings</small>
    </motion.div>}
    </AnimatePresence>
    </motion.div>
</div>
  );
}

export default Exercise;